import {
    API_ROOT
}
from '../util/config'; //自动获取IP
// import Vue from 'vue'
const storePrefix = 'chongshi'
export const downloadUrl = API_ROOT || (location.origin + '/'); //自动获取IP
// 存储cookie
export const setCookie = (cname, cvalue, exdays) => {
        var d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        var expires = "expires=" + d.toUTCString()
        console.info(cname + "=" + cvalue + "; " + expires)
        document.cookie = cname + "=" + cvalue + "; " + expires
        console.info(document.cookie)
    }
    // 获取cookie
export const getCookie = (cname) => {
        var name = cname + "="
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1)
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
        }
        return ""
    }
    // 清除cookie
export const clearCookie = (cname) => {
        this.setCookie(cname, "", -1)
    }
    // 存储localStorage
export const setLocalStore = (name, content) => {
        if (!name || typeof name !== 'string') return
        if (typeof content === 'object') {
            content = JSON.stringify(content)
        }
        window.localStorage.setItem(storePrefix + name, content)
    }
    // 存储sessionStorage
export const setSessionStore = (name, content) => {
        if (!name || typeof name !== 'string') return
        if (typeof content === 'object') {
            content = JSON.stringify(content)
        }
        window.sessionStorage.setItem(storePrefix + name, content)
    }
    // 获取localStorage
export const getLocalStore = name => {
        if (!name || typeof name !== 'string') return
        return window.localStorage.getItem(storePrefix + name)
    }
    //  获取sessionStorage
export const getSessionStore = name => {
        if (!name || typeof name !== 'string') return
        return window.sessionStorage.getItem(storePrefix + name)
    }
    // 删除localStorage
export const removeLocalStore = name => {
        if (!name || typeof name !== 'string') return
        window.localStorage.removeItem(storePrefix + name)
    }
    // 删除sessionStorage
export const removeSessionStore = name => {
        if (!name || typeof name !== 'string') return
        window.sessionStorage.removeItem(storePrefix + name)
    }
    // 验证密码的正则, // 6-18位字母开头只能包含数字字母下划线的
export const checkPass = pwd => {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/
        return reg.test(pwd)
    }
    // 验证用户名的正则4到16位（字母，数字，下划线，减号）
export const checkAccount = account => {
        let uPattern = /^[A-Za-z][A-Za-z1-9_-]{2,15}$/
        return uPattern.test(account)
    }
    // 验证手机号正则
export const checkPhoneNumber = phoneNumber => {
        let mPattern = /^((13[0-9])|(17[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/
        return mPattern.test(phoneNumber)
    }
    // 初始密码
export const resetPwd = 'chongshi12345'
    // 下载文件
export const downloadFile = (fileName, content, blobOptions) => {
    // blobOptions = {
    //     type: 'text/word',
    //     endings: 'native' // or transparent
    // }
    blobOptions = blobOptions || {}
    var blob = new Blob([content], blobOptions)
    var a = document.createElement('a')
    a.innerHTML = fileName
        // 指定生成的文件名
    a.download = fileName
    a.href = URL.createObjectURL(blob)
    document.body.appendChild(a)
    var evt = document.createEvent("MouseEvents")
    evt.initEvent("click", false, false)
    a.dispatchEvent(evt)
    document.body.removeChild(a)
}


// WEBPACK FOOTER //
// ./src/common/common.js